import { useMutation } from '@tanstack/react-query';

import { updatePatientCcmStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

interface Props {
  onSuccess?: () => void;
}

export const useUpdatePatientCcmStatus = ({ onSuccess }: Props = {}) => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updatePatientCcmStatusFn,
    onSuccess(data, variables) {
      updateCache(variables.patientGuid, {
        ccmStatus: variables.dischargeStatus,
      });
      if (onSuccess) {
        onSuccess();
      }
    },
  });

  return { updateCcmStatus: mutateAsync, ccmStatusLoading: isLoading };
};
